import React from 'react';
import { ReactComponent as Events } from '../../../../assets/svg/ProjectOverview/events.svg';
import { ReactComponent as Finances } from '../../../../assets/svg/ProjectOverview/finances.svg';
import { ReactComponent as HardDrive } from '../../../../assets/svg/ProjectOverview/harddrives.svg';
import { ReactComponent as Deliverable } from '../../../../assets/svg/ProjectOverview/deliverables.svg';
import { ReactComponent as Albums } from '../../../../assets/svg/ProjectOverview/albums.svg';

const ProjectInfoCards = ({ cardsbgColor, designColor, opacity, iconType, data }) => {
	function checkIcon() {
		if (iconType === 'events') {
			return <Events />;
		} else if (iconType === 'finances') {
			return <Finances />;
		} else if (iconType === 'drives') {
			return <HardDrive />;
		} else if (iconType === 'deliverable') {
			return <Deliverable />;
		} else {
			return <Albums />;
		}
	}

	return (
		<div className="Infocards" style={{ background: cardsbgColor }}>
			<div className="cardsDetailsContainer">
				<div className="iconContainer">
					<div className="iconholder">{checkIcon()}</div>
				</div>
				<span className="events">{data.title}</span>
				<span className="countdetails">{data.count}</span>
				<span className="details">{data.details}</span>
			</div>

			<div
				className="infoDesigns1"
				style={{ background: designColor, opacity: opacity }}
			></div>
			<div
				className="infoDesigns2"
				style={{ background: designColor, opacity: opacity }}
			></div>
		</div>
	);
};

export default ProjectInfoCards;
